import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";

const getFilename = (url: string): string => {
  return url.split("/").pop() || url;
};

export const getValueSummary = (mod: EmbeddedMod): string => {
  switch (mod.type) {
    case "text": {
      if (mod.editMode === "html") {
        return mod.replace || mod.html || "--";
      }
      return mod.replace ? `"${mod.replace}"` : "--";
    }
    case "image": {
      return mod.src ? getFilename(mod.src) : "--";
    }
    case "injection": {
      const parts: string[] = [];
      if (mod.css) {
        parts.push("CSS edit");
      }
      if (mod.js) {
        parts.push("JS edit");
      }
      return parts.length > 0 ? parts.join(", ") : "--";
    }
    default:
      return "--";
  }
};
